export default "__VITE_ASSET__1f081d00__"